import { render, staticRenderFns } from "./SmallInput.vue?vue&type=template&id=4308839b&scoped=true&"
import script from "./SmallInput.vue?vue&type=script&lang=js&"
export * from "./SmallInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4308839b",
  null
  
)

export default component.exports